import { stimulus } from './application'
import AccountGroupController from './controllers/account-group'
import AccountPickerController from './controllers/account-picker'
import AccountTypeMappingsController from './controllers/account-type-mappings'
import AccountTypeMappingsCreateFormController from './controllers/account-type-mappings-create-form'
import AccountTypeMappingsItemController from './controllers/account-type-mappings-item'
import ActivitiesPanelController from './controllers/activities-panel'
import AlertController from './controllers/alert'
import AmountThresholdController from './controllers/amount-threshold'
import AttachmentManagerController from './controllers/attachment-manager'
import AttachmentManagerItemController from './controllers/attachment-manager-item'
import AttachmentNotesController from './controllers/attachment-notes'
import AutosizeController from './controllers/autosize'
import BulkActionsController from './controllers/bulk-actions'
import BulkDetailsController from './controllers/bulk-details'
import BusyElementsController from './controllers/busy-elements'
import ButtonGroupController from './controllers/button-group'
import ClipboardController from './controllers/clipboard'
import ColorPaletteController from './controllers/color-palette'
import ColorPickerController from './controllers/color-picker'
import ComboBoxController from './controllers/combo-box'
import CropperController from './controllers/cropper'
import DatepickerController from './controllers/datepicker'
import DetailsController from './controllers/details'
import DispatchController from './controllers/dispatch'
import DownloadAllController from './controllers/download-all'
import DrawerController from './controllers/drawer'
import DrawerFrameController from './controllers/drawer-frame'
import DropdownController from './controllers/dropdown'
import DropzoneController from './controllers/dropzone'
import DropzoneManagerController from './controllers/dropzone-manager'
import EntityRelationsController from './controllers/entity-relations'
import EventModController from './controllers/event-mod'
import FieldEventClassTogglerController from './controllers/field-event-class-toggler'
import FieldRulesController from './controllers/field-rules'
import FilterViewController from './controllers/filter-view'
import FinfolioEntityIdController from './controllers/finfolio-entity-id'
import FinfolioNoteController from './controllers/finfolio-note'
import FinfolioNoteListController from './controllers/finfolio-note-list'
import FinfolioSelectController from './controllers/finfolio-select'
import FloatingLabelSelectController from './controllers/floating-label-select'
import FocusTrapController from './controllers/focus-trap'
import FormChangeController from './controllers/form-change'
import FxController from './controllers/fx'
import IdentitySwitcherController from './controllers/identity-switcher'
import ImageFieldController from './controllers/image-field'
import InputRevealController from './controllers/input-reveal'
import IntegrationController from './controllers/integration'
import LoginFormController from './controllers/login-form'
import LoginOtpFormController from './controllers/login-otp-form'
import ModalController from './controllers/modal'
import NestedRecordsController from './controllers/nested-records'
import NumberInputController from './controllers/number-input'
import OverflowArrowController from './controllers/overflow-arrow'
import PageNavOutlineController from './controllers/page-nav-outline'
import PaginationController from './controllers/pagination'
import PartialFormChangesController from './controllers/partial-form-changes'
import PriorityController from './controllers/priority'
import ProgressBarController from './controllers/progress-bar'
import ProgressWheelController from './controllers/progress-wheel'
import RemoteSubmissionSearchController from './controllers/remote-submission-search'
import RepCodeController from './controllers/rep-code'
import ScrollController from './controllers/scroll'
import ScrollbarController from './controllers/scrollbar'
import SnackBarController from './controllers/snack-bar'
import SortableController from './controllers/sortable'
import StickyController from './controllers/sticky'
import StreamManagerController from './controllers/stream-manager'
import SubmissionController from './controllers/submission'
import SubmissionAccountSearchController from './controllers/submission-account-search'
import SubmissionContainerController from './controllers/submission-container'
import SubmissionDeletedDialogController from './controllers/submission-deleted-dialog'
import SubmissionIndexController from './controllers/submission-index'
import SubmissionViewExtensionFieldsController from './controllers/submission-view-extension-fields'
import SubmissionViewFieldsController from './controllers/submission-view-fields'
import SubmissionsTableController from './controllers/submissions-table'
import SupervisedPersonController from './controllers/supervised-person'
import SwitchController from './controllers/switch'
import SyncSettingsController from './controllers/sync-settings'
import SystemNotificationController from './controllers/system-notification'
import TabGroupController from './controllers/tab-group'
import TextEditorController from './controllers/text-editor'
import TimestampController from './controllers/timestamp'
import ToggleController from './controllers/toggle'
import TomSelectController from './controllers/tom-select'
import TooltipController from './controllers/tooltip'

stimulus.register('account-group', AccountGroupController)
stimulus.register('account-picker', AccountPickerController)
stimulus.register('account-type-mappings', AccountTypeMappingsController)
stimulus.register('account-type-mappings-create-form', AccountTypeMappingsCreateFormController)
stimulus.register('account-type-mappings-item', AccountTypeMappingsItemController)
stimulus.register('alert', AlertController)
stimulus.register('activities-panel', ActivitiesPanelController)
stimulus.register('amount-threshold', AmountThresholdController)
stimulus.register('attachment-manager', AttachmentManagerController)
stimulus.register('attachment-manager-item', AttachmentManagerItemController)
stimulus.register('attachment-notes', AttachmentNotesController)
stimulus.register('autosize', AutosizeController)
stimulus.register('bulk-actions', BulkActionsController)
stimulus.register('bulk-details', BulkDetailsController)
stimulus.register('busy-elements', BusyElementsController)
stimulus.register('button-group', ButtonGroupController)
stimulus.register('clipboard', ClipboardController)
stimulus.register('color-palette', ColorPaletteController)
stimulus.register('color-picker', ColorPickerController)
stimulus.register('combo-box', ComboBoxController)
stimulus.register('input-reveal', InputRevealController)
stimulus.register('crop', CropperController)
stimulus.register('datepicker', DatepickerController)
stimulus.register('details', DetailsController)
stimulus.register('dispatch', DispatchController)
stimulus.register('download-all', DownloadAllController)
stimulus.register('drawer', DrawerController)
stimulus.register('drawer-frame', DrawerFrameController)
stimulus.register('dropdown', DropdownController)
stimulus.register('dropzone', DropzoneController)
stimulus.register('dropzone-manager', DropzoneManagerController)
stimulus.register('entity-relations', EntityRelationsController)
stimulus.register('event-mod', EventModController)
stimulus.register('field-event-class-toggler', FieldEventClassTogglerController)
stimulus.register('field-rules', FieldRulesController)
stimulus.register('filter-view', FilterViewController)
stimulus.register('finfolio-entity-id', FinfolioEntityIdController)
stimulus.register('finfolio-note', FinfolioNoteController)
stimulus.register('finfolio-note-list', FinfolioNoteListController)
stimulus.register('finfolio-select', FinfolioSelectController)
stimulus.register('floating-label-select', FloatingLabelSelectController)
stimulus.register('focus-trap', FocusTrapController)
stimulus.register('form-change', FormChangeController)
stimulus.register('fx', FxController)
stimulus.register('identity-switcher', IdentitySwitcherController)
stimulus.register('image-field', ImageFieldController)
stimulus.register('integration', IntegrationController)
stimulus.register('login-form', LoginFormController)
stimulus.register('login-otp-form', LoginOtpFormController)
stimulus.register('modal', ModalController)
stimulus.register('nested-records', NestedRecordsController)
stimulus.register('number-input', NumberInputController)
stimulus.register('overflow-arrow', OverflowArrowController)
stimulus.register('page-nav-outline', PageNavOutlineController)
stimulus.register('pagination', PaginationController)
stimulus.register('partial-form-changes', PartialFormChangesController)
stimulus.register('priority', PriorityController)
stimulus.register('progress-bar', ProgressBarController)
stimulus.register('progress-wheel', ProgressWheelController)
stimulus.register('remote-submission-search', RemoteSubmissionSearchController)
stimulus.register('rep-code', RepCodeController)
stimulus.register('scroll', ScrollController)
stimulus.register('scrollbar', ScrollbarController)
stimulus.register('snack-bar', SnackBarController)
stimulus.register('sortable', SortableController)
stimulus.register('sticky', StickyController)
stimulus.register('stream-manager', StreamManagerController)
stimulus.register('submission', SubmissionController)
stimulus.register('submission-account-search', SubmissionAccountSearchController)
stimulus.register('submission-container', SubmissionContainerController)
stimulus.register('submission-deleted-dialog', SubmissionDeletedDialogController)
stimulus.register('submission-index', SubmissionIndexController)
stimulus.register('submission-view-extension-fields', SubmissionViewExtensionFieldsController)
stimulus.register('submission-view-fields', SubmissionViewFieldsController)
stimulus.register('submissions-table', SubmissionsTableController)
stimulus.register('supervised-person', SupervisedPersonController)
stimulus.register('switch', SwitchController)
stimulus.register('sync-settings', SyncSettingsController)
stimulus.register('system-notification', SystemNotificationController)
stimulus.register('tab-group', TabGroupController)
stimulus.register('text-editor', TextEditorController)
stimulus.register('timestamp', TimestampController)
stimulus.register('toggle', ToggleController)
stimulus.register('tom-select', TomSelectController)
stimulus.register('tooltip', TooltipController)
